<template>
  <div class="card_box" v-for="(item,index) in productService" :key="item.id">
    <div :class="`box_inner_${index} sp_inner_box_vip_product`">
      <div class="title_name">
        <span class="title_text">
          <span v-if="item.productSort===1">{{ t('userinfo.vip.service.1') }}</span>
          <span v-else-if="item.productSort===2">{{ t('userinfo.vip.service.2') }}</span>
          <span v-else-if="item.productSort===3">{{ t('userinfo.vip.service.3') }}</span>
          <span v-else-if="item.productSort===4">{{ t('userinfo.vip.service.4') }}</span>
          <el-popover
              placement="bottom"
              trigger="hover"
              width="240"
              popper-class="vip-product-help-popper"
              effect="dark"
          >
            <template #default>
              <span v-if="item.productSort===1">{{ t('vip.resource_explain.seat') }}</span>
              <span v-else-if="item.productSort===2">{{ t('vip.resource_explain.storage') }}</span>
              <span v-else-if="item.productSort===3">{{ t('vip.resource_explain.edm') }}</span>
              <span v-else-if="item.productSort===4">{{ t('vip.resource_explain.ai_points') }}</span>
            </template>
            <template #reference>
              <span class="vip-product-help-reference">
                <img class="vip-product-help-icon" :src="desProductIcon" alt="" />
              </span>
            </template>
          </el-popover>
        </span>
      </div>
      <div style="margin-top: 5px" class="des">
        <template v-if="item.productSort===1">
          {{ t('common.text.per.station.year', {number: item?.productNum}) }}
        </template>
        <template v-else-if="item.productSort===2">
          {{ t('common.text.per.GB.year', {number: spaceSizeFormat(item?.productNum, false)}) }}
        </template>
        <template v-else-if="item.productSort===3">
          {{ t('common.text.per.feng.year', {number: item?.productNum}) }}
        </template>
        <template v-else-if="item.productSort===4">
          {{ t('common.text.per.year', {number: item?.productNum}) }}
        </template>
      </div>
      <div class="pre_price">
        {{ t('common.yj', {price: item.productPrice}) }}
      </div>
      <div class="price_box">
        <span class="red ft-24">¥</span>
        <span class="red ft-24">{{ item.productCheapPrice.toFixed(2) }}</span>
        <div class="vip-price-tag">
          {{ t('common.product.price.member') }}
          <div class="triangle"></div>
        </div>
      </div>
      <div style="margin-top: 6px;">
        <div class="buy_button" @click="handleClickToBuy(item,1)">{{ t('common.buy.now') }}</div>
        <div v-if="canPromote" class="buy_button_free" @click="handleClickFreeGet(item)">{{ t('common.free.get') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {spaceSizeFormat} from "../../../utils/file";
import desProductIcon from '@/assets/des_product.png'

const { t } = useI18n()
const emit = defineEmits(['openInvite'])

const store = useStore()

const isEnterpriseMainUser = computed(() => store.getters["user/isEnterpriseMainUser"])
const isNormalUser = computed(() => store.getters["user/isNormalUser"])
const canPromote = computed(() => isEnterpriseMainUser.value || isNormalUser.value)

const productService = computed(() => store.state.buystorage.allProductList)

const router = useRouter()
const handleClickToBuy = async (item, type) => {
  const {id, productSort} = item;
  // await store.commit("buystorage/setCheckIndex", id * 1)
  router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: type}})
}

const handleClickFreeGet = async (item) => {
  if (!canPromote.value) return
  emit('openInvite', item)
}

onMounted(async () => {
  await store.dispatch("buystorage/getMailProductListApis", 1)
})

</script>

<style lang="less" scoped>
.card_box {
  width: 24%;
  min-height: 153px;
  height: max-content;
  border-radius: 5px;
}

.sp_inner_box_vip_product {
  width: 100%;
  height: 100%;
  padding: 15px;

  .title_name {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
  }

  .title_text {
    position: relative;
    display: inline-block;
  }

  .vip-product-help-reference {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translate(6px, -50%);
    display: inline-flex;
    align-items: center;
  }

  .vip-product-help-icon {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    cursor: pointer;
  }

  .des {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #9B9B9B;
  }

  .price_box {
    margin-top: 5px;
    text-align: center;
    height: 30px;
  }

  .pre_price {
    margin-top: 5px;
    text-align: center;
    //text-decoration: line-through;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #AAAAAA;
  }
}

.box_inner_0 {
  background: url("../../../assets/vip/product_1.png") no-repeat 100% /cover;
}

.box_inner_1 {
  background: url("../../../assets/vip/product_2.png") no-repeat 100% /cover;
}

.box_inner_2 {
  background: url("../../../assets/vip/product_3.png") no-repeat 100% /cover;
}

.box_inner_3 {
  background: url("../../../assets/vip/product_4.png") no-repeat 100% /cover;
}

.ft-12 {
  font-size: 12px;
}

.ft-24 {
  font-size: 24px;
}

.red {
  color: #D93737;
}

.vip-price-tag {
  width: 42px;
  position: relative;
  left: 76%;
  top: -35px;
  background-color: var(--el-color-danger);;
  color: #fff;
  font-size: 10px;
  padding: 0 6px;
  height: 14px;
  line-height: 14px;
  border-radius: 3px 3px 3px 0px;
  font-weight: bold;
  text-align: center;
}

/* 下方小三角 */
.triangle {
  position: absolute;
  bottom: -4px;
  left: 3px;
  top: 6px;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #F2270C; /* 红色三角向右 */
}

.buy_button {
  margin: auto;
  width: 130px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: rgba(217, 55, 55, 0.15);
  border-radius: 4px;
  border: 1px solid #D93737;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #D93737;
  cursor: pointer;
}

.buy_button_free{
  margin: auto;
  width: 130px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #d7e6fd;
  border-radius: 4px;
  border: 1px solid #0073FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #0073FF;
  cursor: pointer;
  margin-top: 5px;
}
</style>

<style lang="less">
.vip-product-help-popper {
  width: 240px !important;
  max-width: 240px !important;
  min-width: 150px !important;
}

.vip-product-help-popper .el-popover__content {
  display: block;
  width: 240px !important;
  max-width: 240px !important;
  white-space: normal !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
  line-height: 18px;
  font-size: 12px;
  min-width: 150px !important;
}
:deep(.el-popover){
  width: 240px !important;
  min-width: 150px !important;
}
</style>